import { useEffect, useState } from "react";
import moment from "moment";
import { CLIENT_TYPE, CONTACT_TYPE } from "#app/pages/Relations/Tasks/form/TaskForm";
import { ContactTaskRepeatConstants, UserTaskTypeConstants } from "finhelper";

export const useTaskForm = (
    form: any,
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>,
    setForm: React.Dispatch<React.SetStateAction<any>>
) => {
    let initDate = moment().startOf("hour");

    const [type, setType] = useState(CLIENT_TYPE);
    const [search, setSearch] = useState("");
    const [showContactSelect, setShowContactSelect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(null);
    const [typeId, setTypeId] = useState(UserTaskTypeConstants.CALLS);
    const [comment, setComment] = useState("");
    const [contactId, setContactId] = useState("");
    const [startDate, setStartDate] = useState(initDate.toDate());
    const [endDate, setEndDate] = useState(initDate.clone().add(30, "minutes").toDate());
    const [repeatId, setRepeatId] = useState(ContactTaskRepeatConstants.REPEAT_NONE);
    const [contacts, setContacts] = useState([]);
    const [formErrors, changeFormErrors] = useState<Record<string, string[]>>({});

    useEffect(() => {
        if (form) {
            setId(form.id || null);

            if (form.user_id) {
                setContactId(form.user_id + "-user");
                setType(form.type || CLIENT_TYPE);
            } else if (form.contact_id) {
                setContactId(form.contact_id + "-contact");
                setType(form.type || CONTACT_TYPE);
            }

            setTypeId(form.type_id || UserTaskTypeConstants.CALLS);
            setComment(form.comment || "");
            setStartDate(
                moment(form.start_at_datetime, "DD.MM.YYYY HH:mm:ss").toDate() || initDate.toDate()
            );
            setEndDate(
                moment(form.end_at_datetime, "DD.MM.YYYY HH:mm:ss").toDate() ||
                    initDate.clone().add(30, "minutes").toDate()
            );
            setRepeatId(form.repeat_id || ContactTaskRepeatConstants.REPEAT_NONE);
        }
    }, [form]);

    const clearForm = () => {
        let startDate, endDate;
        if (moment().minutes() < 30) {
            startDate = moment().startOf("hour");
            endDate = moment().minutes(30);
        } else {
            startDate = moment().minutes(30);
            endDate = moment().startOf("hour").add(1, "hour");
        }
        setId(null);
        setContactId("");
        setTypeId(UserTaskTypeConstants.CALLS);
        setComment("");
        setStartDate(startDate.toDate());
        setEndDate(endDate.toDate());
        setRepeatId(ContactTaskRepeatConstants.REPEAT_NONE);
    };

    const closeForm = () => {
        clearForm();
        changeFormErrors({});
        setModalVisible(false);
        setForm(null);
        setType(1);
    };

    const hasError = (fieldName: string) => {
        if (formErrors && formErrors[fieldName] && formErrors[fieldName].length > 0) {
            return true;
        }
    };

    const getError = (fieldName: string) => {
        if (
            formErrors &&
            typeof formErrors[fieldName] !== "undefined" &&
            formErrors[fieldName].length > 0
        ) {
            return formErrors[fieldName][0];
        }
    };

    return {
        id,
        setId,
        type,
        setType,
        search,
        setSearch,
        showContactSelect,
        setShowContactSelect,
        loading,
        setLoading,
        typeId,
        setTypeId,
        comment,
        setComment,
        contactId,
        setContactId,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        repeatId,
        setRepeatId,
        contacts,
        setContacts,
        formErrors,
        changeFormErrors,
        hasError,
        getError,
        closeForm,
    };
};
